/**
 * SetTransition entity validation rules.
 * Direction, TargetSet, and ActionWorkflow are required for a functional transition rule.
 */

import { getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

export function getSetTransitionWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];

    const displayName = getEntityAttrString(data, 'DisplayName');
    if (!displayName) {
        warnings.push({
            message: 'Display Name should not be empty.',
            severity: 'warning',
            attributeDisplayNames: ['Display Name']
        });
    }

    const direction = getEntityAttrString(data, 'Direction');
    if (!direction) {
        warnings.push({
            message: 'Direction is required (In or Out).',
            severity: 'warning',
            attributeDisplayNames: ['Direction']
        });
    }

    const targetSet = getEntityAttrString(data, 'TargetSet');
    if (!targetSet) {
        warnings.push({
            message: 'Target Set is required -- the transition will not trigger without a set reference.',
            severity: 'warning',
            attributeDisplayNames: ['Target Set']
        });
    }

    const actionWorkflow = getEntityAttrString(data, 'ActionWorkflow');
    if (!actionWorkflow) {
        warnings.push({
            message: 'Action Workflow is required -- the transition will not execute without a workflow reference.',
            severity: 'warning',
            attributeDisplayNames: ['Action Workflow']
        });
    }

    return warnings;
}
